module.exports = __webpack_public_path__ + "static/media/chevron-up.09a92437.svg";